import { useMemo } from 'react';

import SsidChartRoundedIcon from '@mui/icons-material/SsidChartRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import CompareArrowsRoundedIcon from '@mui/icons-material/CompareArrowsRounded';
import AddChartRoundedIcon from '@mui/icons-material/AddchartRounded';
import { paths } from 'src/routes/paths';
import SvgColor from 'src/components/svg-color';
import AutoGraphRoundedIcon from '@mui/icons-material/AutoGraphRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import {
  SquareFootRounded,
  PaidRounded,
  ShoppingCart,
  Payments,
  AccountBalance,
  CreditCard,
} from '@mui/icons-material';

// routes
// components
// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  education: <SchoolRoundedIcon />,
  networth: <PaidRounded />,
  income: <Payments />,
  expenses: <ShoppingCart />,
  cashflow: <SsidChartRoundedIcon />,
  assets: <AccountBalance />,
  liabilities: <CreditCard />,
  transactions: <ReceiptLongRoundedIcon />,
  settings: icon('ic_setting'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'Pages',
        items: [
          {
            title: 'Menu',
            path: paths.dashboard.root,
            icon: ICONS.banking,
            children: [
              { title: 'Dashboard', path: paths.dashboard.overview, icon: ICONS.dashboard },
              {
                title: 'Transactions',
                key: 'expense',
                path: paths.dashboard.transactions,
                icon: ICONS.transactions /* (
                  <IconButton>
                    <Badge
                      badgeContent={`${unknown?.totalCount || 0}${
                        unknown?.totalCount >= 20 ? '+' : ''
                      }`}
                      color={unknown?.totalCount > 0 ? 'error' : 'default'}
                      children={ICONS.transactions}
                    />
                  </IconButton>
                ), */,
              },
              {
                title: 'Net Worth',
                path: paths.dashboard.networth,
                keyword: 'networth',
                icon: ICONS.networth,
              },
              {
                title: 'Income',
                path: paths.dashboard.income,
                keyword: 'income',
                icon: ICONS.income,
              },
              {
                title: 'Expenses',
                path: paths.dashboard.expenses,
                keyword: 'expenses',
                icon: ICONS.expenses,
              },
              {
                title: 'Cashflow',
                path: paths.dashboard.cashflow,
                keyword: 'cashflow',
                icon: ICONS.cashflow,
              },
              {
                title: 'Assets',
                path: paths.dashboard.assets,
                keyword: 'assets',
                icon: ICONS.assets,
              },
              {
                title: 'Liabilities',
                keyword: 'liabilities',
                path: paths.dashboard.liabilities,
                icon: ICONS.liabilities,
              },
            ],
          },

          {
            title: 'Reports',
            path: paths.dashboard.reports,
            icon: ICONS.invoice,
            children: [
              { title: 'Actual', path: paths.dashboard.actual, icon: <HistoryRoundedIcon /> },
              { title: 'Budget', path: paths.dashboard.budget, icon: <AddChartRoundedIcon /> },
              {
                title: 'Actual vs Budget',
                path: paths.dashboard.budgetVsActual,
                icon: <CompareArrowsRoundedIcon />,
              },
              {
                title: 'Budget Forecast',
                path: paths.dashboard.forecast,
                icon: <AutoGraphRoundedIcon />,
              },
            ],
          },
          {
            title: 'Settings',
            path: paths.dashboard.settings,
            icon: ICONS.settings,
            children: [
              {
                title: 'Assumptions & Scenarios',
                path: paths.dashboard.scenarios,
                icon: <SquareFootRounded />,
              },
              { title: 'Accounts', path: paths.dashboard.accounts, icon: ICONS.banking },
              { title: 'Feedback', path: paths.dashboard.contact, icon: ICONS.chat },
            ],
          },
        ],
      },

      {
        title: 'More',
        path: 'https://pp4.c8d.myftpupload.com/learning/',
        icon: ICONS.education,
        subheader: 'Info',
        items: [
          {
            title: 'Education',
            path: 'https://pp4.c8d.myftpupload.com/learning/',
            icon: ICONS.education,
            subheader: 'Pages',
            external: true,
            // children: [
            //   {
            //     title: 'Assumptions',
            //     path: paths.dashboard.assumptions,
            //     icon: <SquareFootRounded />,
            //   },
            //   { title: 'Accounts', path: paths.dashboard.accounts, icon: ICONS.banking },
            //   { title: 'Feedback', path: paths.dashboard.contact, icon: ICONS.chat },
            // ],
          },
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      // {
      //   subheader: 'management',
      //   items: [
      //     {
      //       title: 'user',
      //       path: paths.dashboard.group.root,
      //       icon: ICONS.user,
      //       children: [
      //         { title: 'four', path: paths.dashboard.group.root },
      //         { title: 'five', path: paths.dashboard.group.five },
      //         { title: 'six', path: paths.dashboard.group.six },
      //       ],
      //     },
      //   ],
      // },
    ],
    []
  );

  return data;
}
